import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import heroImage from "./images/ubercare.png";

const useUserId = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  return queryParams.get("userId");
};

function Home() {
  const userId = useUserId();

  useEffect(() => {
    if (userId) localStorage.setItem("userID", userId);
  }, [userId]);

  return (
    <div className="landing-page">
      <style>
        {`
          .landing-page {
            min-height: calc(100vh - 112px);
            background: #2f3440;
            padding: 20px;
            box-sizing: border-box;
          }

          .landing-shell {
            background: #dce3ea;
            border: 1px solid #9ab1c3;
            border-radius: 14px;
            box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
            padding: 22px;
            display: grid;
            gap: 20px;
          }

          .top-layout {
            display: grid;
            grid-template-columns: 250px 1fr;
            gap: 18px;
            align-items: start;
          }

          .topics-card {
            background: #0E5A87;
            color: #fff;
            border-radius: 14px;
            box-shadow: 0 10px 22px rgba(14, 90, 135, 0.28);
            padding: 16px 16px;
            align-self: start;
            min-height: 52vh;
            max-height: 58vh;
            overflow: auto;
          }

          .topics-title {
            margin: 0 0 10px 0;
            color: #ffd760;
            font-size: 18px;
            font-weight: 700;
          }

          .topics-list {
            margin: 0;
            padding-left: 18px;
            display: grid;
            gap: 11px;
            font-size: 15px;
            line-height: 1.36;
          }

          .content-column {
            display: grid;
            gap: 16px;
          }

          .overview-card {
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid #cfdae4;
            box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
            padding: 18px 20px;
            display: grid;
            grid-template-columns: 1fr minmax(280px, 46%);
            gap: 18px;
            align-items: center;
          }

          .overview-title {
            margin: 0 0 8px 0;
            color: #0E5A87;
            font-size: 28px;
            font-weight: 800;
          }

          .overview-subtitle {
            margin: 0 0 8px 0;
            color: #0E5A87;
            font-size: 24px;
            font-weight: 700;
          }

          .overview-text {
            margin: 0 0 12px 0;
            color: #1f2937;
            font-size: 16px;
            line-height: 1.48;
          }

          .hero-image {
            width: 100%;
            max-width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 14px;
            box-shadow: 0 12px 24px rgba(15, 23, 42, 0.18);
            border: 1px solid #d2dde7;
          }

          .roles-card {
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid #cfdae4;
            box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
            padding: 18px 20px;
          }

          .works-section {
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid #cfdae4;
            box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
            padding: 24px;
            margin-bottom: 24px;
          }

          .works-title {
            margin: 0;
            color: #0E5A87;
            font-size: 30px;
            font-weight: 800;
          }

          .works-note {
            margin: 8px 0 18px 0;
            color: #334155;
            font-size: 15px;
          }

          .works-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(240px, 1fr));
            gap: 16px;
          }

          .work-card {
            background: #ffffff;
            border-radius: 14px;
            box-shadow: 0 8px 20px rgba(15, 23, 42, 0.07);
            border: 1px solid #d7e1ea;
            padding: 24px;
            margin-bottom: 24px;
          }

          .work-card h3 {
            margin: 0 0 10px 0;
            color: #0E5A87;
            font-size: 22px;
            line-height: 1.25;
          }

          .work-card p {
            margin: 0 0 12px 0;
            color: #1f2937;
            font-size: 15px;
            line-height: 1.45;
          }

          .work-bullets {
            margin: 0 0 12px 0;
            padding-left: 18px;
            color: #1f2937;
            font-size: 15px;
            line-height: 1.45;
          }

          .video-placeholder {
            border: 1px dashed #a7bed0;
            background: #f7fafc;
            border-radius: 12px;
            min-height: 92px;
            display: grid;
            place-items: center;
            color: #64748b;
            font-weight: 700;
            font-size: 14px;
          }

          .roles-title {
            margin: 0 0 14px 0;
            color: #0E5A87;
            font-size: 30px;
            font-weight: 800;
          }

          .roles-grid {
            display: grid;
            grid-template-columns: repeat(4, minmax(170px, 1fr));
            gap: 14px;
          }

          .role-column h3 {
            margin: 0 0 8px 0;
            color: #b45309;
            font-size: 22px;
            font-weight: 800;
            line-height: 1.2;
          }

          .role-column ul {
            margin: 0;
            padding-left: 18px;
            display: grid;
            gap: 6px;
            color: #0f172a;
            font-size: 15px;
            line-height: 1.35;
          }

          @media (max-width: 1120px) {
            .top-layout {
              grid-template-columns: 220px 1fr;
            }

            .roles-grid {
              grid-template-columns: repeat(2, minmax(220px, 1fr));
            }

            .works-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 860px) {
            .top-layout {
              grid-template-columns: 1fr;
            }

            .topics-card {
              min-height: auto;
              max-height: none;
            }

            .overview-card {
              grid-template-columns: 1fr;
            }

            .roles-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>

      <div className="landing-shell">
        <div className="top-layout">
          <aside className="topics-card">
            <h3 className="topics-title">Quick Topics</h3>
            <ul className="topics-list">
              <li>How to Create &amp; Manage a Family Circle Group</li>
              <li>How to Secure and Personalize The Vault</li>
              <li>Specialized Agentic Services for Elders</li>
              <li>Family Controlled Group Analytics</li>
            </ul>
          </aside>

          <div className="content-column">
            <section className="overview-card">
              <div>
                <h2 className="overview-title">Family Circle Overview</h2>
                <p className="overview-text">
                  A secure information and collaboration platform designed for families and care providers.
                </p>

                <h3 className="overview-subtitle">Who Uses Family Circle?</h3>
                <p className="overview-text">
                  Family Circle is centered around supporting an elder. Family members and caregivers use it to
                  collaborate, share trusted information, and provide personalized support that improves daily
                  well-being.
                </p>
              </div>
              <img src={heroImage} alt="Family Circle illustration" className="hero-image" />
            </section>

            <section className="roles-card">
              <h2 className="roles-title">Key Roles in the Family Circle</h2>
              <div className="roles-grid">
                <div className="role-column">
                  <h3>Elder Target User</h3>
                  <ul>
                    <li>Personalized daily services</li>
                    <li>Memory support</li>
                    <li>Companionship</li>
                    <li>Reminiscence and connection</li>
                  </ul>
                </div>

                <div className="role-column">
                  <h3>Kin-Keeper (Administrator)</h3>
                  <ul>
                    <li>Sets up the Family Circle group</li>
                    <li>Invites family members and caregivers</li>
                    <li>Maintains the secure Vault</li>
                    <li>Oversees analytics and activity</li>
                  </ul>
                </div>

                <div className="role-column">
                  <h3>Family Members / Caregivers</h3>
                  <ul>
                    <li>Provide day-to-day support</li>
                    <li>Contribute information to the Vault</li>
                    <li>Suggest eldercare services</li>
                    <li>Coordinate with the wider Family Circle</li>
                  </ul>
                </div>

                <div className="role-column">
                  <h3>Agent Assistants</h3>
                  <ul>
                    <li>Support the elder directly</li>
                    <li>Learn preferences over time</li>
                    <li>Personalize interactions</li>
                    <li>Assist with continuity of care</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="works-section">
              <h2 className="works-title">How Family Circle Works</h2>
              <p className="works-note">Note: the following videos are under development.</p>

              <div className="works-grid">
                <article className="work-card">
                  <h3>How to Create &amp; Manage a Family Circle Group</h3>
                  <p>
                    This video explains the Kin-Keeper’s administrative role, including how to create a Family
                    Circle, invite people to join, and create the interactive visual for the group’s home page.
                  </p>
                  <div className="video-placeholder">Video coming soon</div>
                </article>

                <article className="work-card">
                  <h3>How to Secure and Personalize The Vault</h3>
                  <p>
                    This video explains how the Vault stores information that personalizes the elder’s Family
                    Circle experience, and how the Kin-Keeper keeps that information secure and up to date.
                  </p>
                  <div className="video-placeholder">Video coming soon</div>
                </article>

                <article className="work-card">
                  <h3>Specialized Agentic Services for Elders</h3>
                  <p>This video describes the key agentic services that support the elder:</p>
                  <ul className="work-bullets">
                    <li>Biometric services including ElderCHAT and SLEDSS</li>
                    <li>UberCare remote workers</li>
                    <li>Marketplace of Elder Services</li>
                  </ul>
                  <div className="video-placeholder">Video coming soon</div>
                </article>

                <article className="work-card">
                  <h3>Family Controlled Group Analytics</h3>
                  <p>
                    This video shows how the Kin-Keeper manages Family Circle activities and approves elder
                    services using a dashboard that tracks membership, usage, and data analytics.
                  </p>
                  <div className="video-placeholder">Video coming soon</div>
                </article>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
